import { genericOptionsDefaults } from '@widgets/GenericBookings/context/Options';
import { createContext } from 'react';
export const optionsDefaults = {
    ...genericOptionsDefaults,
    dayTicketId: 4,
    minActivities: 2,
    maxActivities: 10,
    isMulti: true,
    isBuilder: false,
};
export const OptionsCTX = createContext(optionsDefaults);
